export const imageUpload = {
	addImage: "Ajouter une image",
	validating: "Validation de l'image...",
	verifyingDimensions: "Vérification des dimensions et du format...",
	removeImage: "Supprimer l'image téléchargée",
	formatInfo: "JPG ou PNG jusqu'à {{maxSize}}MB et {{width}}x{{height}}px.",
	ariaLabel: {
		fileInput: "Entrée de fichier pour le téléchargement d'image",
		uploadedImage: "Image du produit téléchargée",
		uploadHeading: "Titre de téléchargement",
	},
	errors: {
		fileTooLarge: "Fichier trop volumineux. Taille maximale: {{maxSize}}MB",
		fileInvalidType: "Type de fichier invalide. Utilisez uniquement JPG ou PNG.",
		fileDimensionsTooLarge: "Dimensions trop grandes. Maximum: {{width}}x{{height}}px",
		generalError: "Erreur lors du téléchargement de l'image",
		validationError: "Erreur lors de la validation de l'image",
		invalidFile: "Fichier invalide",
	},
};
